/**
 * Blog home page
 */

(function($) {

	// Timer for typing
	let typingTimer;
	let doneTypingInterval = 500;

	// Some important elements
	const blogPostsCont = document.getElementById('blog-posts-cont');
	const blogSearchBar = document.getElementById('coeff-blog-search');
	const blogSearchIcon = document.getElementById('blog-search-icon');
	const blogPosts = document.getElementById('coeff-blog-posts');
	const paged = blogPosts.dataset.paged;

	/**
	 * Search the blog posts
	 * @param {string} value Search value
	 */
	const blogSearch = (value) => {
		// Change the search icon to a loader
		blogSearchIcon.classList.remove('fa-solid');
		blogSearchIcon.classList.remove('fa-magnifying-glass');
		blogSearchIcon.classList.add('fas');
		blogSearchIcon.classList.add('fa-circle-notch');
		blogSearchIcon.classList.add('fa-spin');

		// Now lets make our ajax request
		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'html',
			data: {
				action: 'coefficient_blog_search_filter',
				query: blogSearchBar.value,
				paged: paged,
			},
			success: function(res) {
				if (res) {
					console.log(blogPosts);
					// Replace the inner html of the blog posts container
					blogPostsCont.innerHTML = res;

					// Revert the search icon back to a magnifying glass
					blogSearchIcon.classList.remove('fas');
					blogSearchIcon.classList.remove('fa-circle-notch');
					blogSearchIcon.classList.remove('fa-spin');
					blogSearchIcon.classList.add('fa-solid');
					blogSearchIcon.classList.add('fa-magnifying-glass');
				}
			},
			error: function(error) {
				alert( 'There was an error loading items. Please contact support if this issue persists' );
			}
		});
	}

	// If there is a blog search bar, we will add an event listener
	if (blogSearchBar) {
		// Add an event listener when the input is changed
		blogSearchBar.addEventListener('input', (e) => {
			// Wait for the user to stop typing
			clearTimeout(typingTimer);

			// If there is a value
			typingTimer = setTimeout(() => {
				// Search the blog posts
				blogSearch(blogSearchBar.value);
			}, doneTypingInterval);

		});
	}
}(jQuery) );